/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RelationshipsProfessionalsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RelationshipsProfessionalsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/RelationshipsProfessionalsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="RelationshipsProfessionalsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-ZRjMio': alignSelf,'--mt-2-ZRjMio': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZRjMio': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZRjMio': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZRjMio': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZRjMio': opacity,'--w-10-ZRjMio': typeof width === 'number' ? `${width}px` : width,'--h-11-ZRjMio': typeof height === 'number' ? `${height}px` : height,'--f-12-ZRjMio': fill,'--a-7-ZRjMio': isAnimated ? animation : "none",'--sd-8-ZRjMio': isAnimated ? strokeDashoffset : 0,'--sd-9-ZRjMio': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="RelationshipsProfessionalsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M12.156 4.501H7.802a1.464 1.464 0 00-1.445 1.005l-.715 1.772a27.234 27.234 0 018.699-.002l-.74-1.773a1.464 1.464 0 00-1.445-1.002zm4.181 4.433a.48.48 0 01.336.617l-1.724 5.276a.976.976 0 01-.928.673H5.976a.976.976 0 01-.928-.673L3.324 9.55a.48.48 0 01.336-.617 25.943 25.943 0 0112.677 0zm-7.803 2.278a.61.61 0 000 1.22h.854v.855a.61.61 0 001.22 0v-.854h.855a.61.61 0 000-1.22h-.854v-.855a.61.61 0 00-1.22 0v.854h-.855z"
 style={{'--f-12-ZRjMio': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}